import type { NitroFetchRequest } from 'nitropack/types';

export const useFetchAPI = <T extends NitroFetchRequest = NitroFetchRequest>(
  url: T,
  // biome-ignore lint/suspicious/noExplicitAny: Until we find the appropriate type for this.
  options?: any,
) =>
  useFetch(url, {
    ...options,
    $fetch: useNuxtApp().$fetchAPI as typeof $fetch,
  });

export const useLazyFetchAPI = <
  T extends NitroFetchRequest = NitroFetchRequest,
>(
  url: T | (() => T),
  // biome-ignore lint/suspicious/noExplicitAny: Until we find the appropriate type for this.
  options?: any,
) =>
  useLazyFetch(url, {
    ...options,
    $fetch: useNuxtApp().$fetchAPI as typeof $fetch,
  });
